// Primeiro import do app, e a ordem importa: precisa rodar antes do primeiro
// `parse` do Zod. Ver o comentário do arquivo.
import "./zod-sem-jit.js";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import "./estilos/fontes.css";
import "./estilos/tokens.css";
import "./estilos/base.css";
import "./estilos/movimento.css";
import "./estilos/caderno.css";
import "./estilos/grifo.css";
import { aplicarTamanho, tamanhoGuardado } from "./tamanho-do-texto.js";

/*
 * Antes da primeira pintura: o ajuste de tamanho do texto mexe no `font-size` da
 * raiz, e aplicá-lo depois da primeira renderização faria a tela inteira pular
 * de tamanho na frente de quem abriu o app. Fica aqui, e não dentro do React,
 * porque aqui é o último ponto que ainda roda com `#raiz` vazio.
 */
aplicarTamanho(tamanhoGuardado());

const raiz = document.getElementById("raiz");
if (!raiz) throw new Error("Elemento #raiz não encontrado.");

/**
 * Registra o service worker.
 *
 * Fora do React de propósito: ele não faz parte da árvore e não deve esperar a
 * primeira renderização. Se falhar, o app funciona igual — a PWA é um ganho,
 * não um requisito.
 */
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js").catch(() => {
      /* sem service worker o app continua funcionando online */
    });
  });
}

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
